export default __webpack_public_path__ + "static/media/2-3_image7.764e2350.png";